(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('agreement', {
            parent: 'entity',
            url: '/agreement?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.agreement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/agreement/agreements.html',
                    controller: 'AgreementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('agreement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('agreement-detail', {
            parent: 'entity',
            url: '/agreement/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.agreement.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/agreement/agreement-detail.html',
                    controller: 'AgreementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('agreement');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Agreement', function($stateParams, Agreement) {
                    return Agreement.get({id : $stateParams.id});
                }]
            }
        })
        .state('agreement.new', {
            parent: 'agreement',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/agreement/agreement-dialog.html',
                    controller: 'AgreementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                promisedQuantity: null,
                                agreedPrice: null,
                                description: null,
                                priority: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('agreement', null, { reload: true });
                }, function() {
                    $state.go('agreement');
                });
            }]
        })
        .state('agreement.edit', {
            parent: 'agreement',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/agreement/agreement-dialog.html',
                    controller: 'AgreementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Agreement', function(Agreement) {
                            return Agreement.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('agreement', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('agreement.delete', {
            parent: 'agreement',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/agreement/agreement-delete-dialog.html',
                    controller: 'AgreementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Agreement', function(Agreement) {
                            return Agreement.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('agreement', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
